export const SET_EVENTS = 'SET_EVENTS';

export interface EventState {
    byIds:
        | {
              [id: string]: EventData;
          }
        | {};
}

export interface EventData {
    id: string | number;
    data: any;
}

export interface SetEventsAction {
    type: typeof SET_EVENTS;
    payload: EventData;
}

export type SetEventsTypes = SetEventsAction;
